<template>
  <div>
    <section class="section section-sp">
      <header class="list list-align">
        <h2
          v-if="isCheerUsersExists"
          class="sectionHd"
        >
          このプレスリリースを<br class="sp-show">応援してるユーザー
        </h2>
        <div
          class="sectionBtn"
          :class="{ 'cheer-users-none': !isCheerUsersExists }"
        >
          <a
            class="list list-center list-align cheer_follow"
            :class="{ cheer: !cheered, cheering: cheered }"
            @click="openModal"
          >
            <div class="svg_cheering">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 15 14.21"
              >
                <defs />
                <title>icon_cheering</title>
                <g
                  id="layer_cheering"
                  data-name="layer_cheering"
                >
                  <g id="layer_cheering_header">
                    <rect
                      class="cls-3"
                      y="0.88"
                      width="1.36"
                      height="13.33"
                    />
                    <path
                      class="cls-3"
                      d="M15,8.88c-5,3-10-3-15,0v-8c5-3,10,3,15,0Z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <p
              class="cheer_title"
              @click="openModal"
            >
              {{ cheered ? "応援中" : "応援する" }}
            </p>
          </a>
        </div>
      </header>
      <div class="cheer_visitor_list">
        <ul class="userList list list-left">
          <li
            v-for="cheerUser in cheerUsers"
            :key="cheerUser.id"
          >
            <img
              :src="cheerUser.picUrl"
              width="50"
              height="50"
            >
          </li>
        </ul>
        <div class="clear" />
      </div>
    </section>

    <div v-if="showModal">
      <Modal>
        <div class="popup_menu">
          <button
            type="button"
            class="closebtn"
            @click="closeModal"
          >
            <span>×</span>
          </button>
        </div>

        <!-- 応援fancybox -->
        <div>
          <div
            v-if="isFacebookLogin === false"
            id="cheer_box"
          >
            <!-- FBログイン -->
            <div class="fb_login_box">
              <div class="lets_login">
                ログインして応援しよう
              </div>
              <p class="need_fb">
                応援するにはFacebookアカウントが必要です。<br>valuepressが許可なくFacebookなどへ投稿することはありません。
              </p>
              <div class="fb_login_guide">
                <a>
                  <div class="fb-login-button FbBtn">
                    <span
                      class="FbBtnLabel"
                      @click="facebookLogin"
                    >Facebookでログイン</span>
                  </div>
                </a>
              </div>
              <div class="fb_login_loading">
                Facebook 認証中<br>
                <img src="/static/image/column3_bx_loader.gif">
              </div>
              <div class="about_cheer">
                <p>応援するとは？</p>
                <div>
                  応援すると、このプレスリリースがランキングで上位表示され、記者から閲覧されやすくなります。
                  <br>
                  また、FacebookやTwitterでシェアすることによって、より多くの記者・一般ユーザー・業界関係者の目に留まる手助けができます。
                </div>
              </div>
            </div>
          </div>
          <!-- /FBログイン -->

          <!-- 応援 -->
          <div
            v-if="isFacebookLogin"
            id="cheer_send"
          >
            <div class="cheer_name">
              <p class="error" />
              {{ name }}を応援します
            </div>
            <!-- facebook 応援ボタン -->
            <button
              id="fb-btn"
              onmouseover="this.style.opacity='0.8'"
              onmouseout="this.style.opacity='1'"
              @click="cheerFacebook"
            >
              <i class="g-icon-flag" />
              <span id="exec_text">Facebookで応援</span>
            </button>
            <!-- /facebook 応援ボタン -->
            <!-- twitter 応援ボタン -->
            <div class="cheer_twitter">
              <a
                id="twitter-intent"
                type="button"
                onmouseover="this.style.opacity='0.8'"
                onmouseout="this.style.opacity='1'"
                @click="cheerTwitter"
              >
                <i class="g-icon-flag" />
                <span>Twitterで応援</span>
              </a>
            </div>
            <!-- /twitter 応援ボタン -->
            <!-- 応援しないボタン -->
            <div class="cheer_close">
              <a
                type="button"
                @click="closeModal"
              >応援しない</a>
            </div>
            <!-- /応援しないボタン -->

            <p class="cheer_effect">
              FacebookやTwitterでシェア(応援)すると、このプレスリリースがランキングで上位表示され、<br>より多くのユーザーの目に留まる手助けができます。
            </p>
          </div>
          <!-- /応援 -->
        </div>
        <!-- /応援fancybox -->
      </Modal>
    </div>
    <!-- /応援説明fancybox -->
  </div>
</template>
<script>
import Modal from "./Modal.vue";
import { loadSDK } from "~/common/facebook_sdk_load";
import { FacebookLogin } from "./Mixins/FacebookLogin";
import { CheerExecutor } from "./Mixins/CheerExecutor";
import { axios } from "~/libs/vp-api-axios";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default {
  name: "SocialCheerBtn",
  components: { Modal },
  mixins: [FacebookLogin, CheerExecutor],
  props: {
    env: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    app: {
      type: String,
      default: ""
    },
    articleId: {
      type: Number,
      default: 0
    },
    userAccountId: {
      type: Number,
      default: 0
    },
    socialShareUrl: {
      type: String,
      default: ""
    },
    session: {
      type: String,
      default: ""
    },
    dummy: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showModal: false,
      cheerUsers: [],
      twitterURL: "",
    };
  },
  computed: {
    isFacebookLogin() {
      return this.fbLogin;
    },
    isChreered() {
      return this.cheered;
    },
    isCheerUsersExists() {
      return this.cheerUsers.length !== 0;
    }
  },
  created() {
    loadSDK(this.app);
  },
  mounted() {
    this.getCheerUsers();
    this.generateTwitterURL();
    this.getLoginStatus();
  },
  updated() {
    if (window.FB !== undefined && !this.fbSdkIsLoaded) {
      this.getLoginStatus();
    }
  },
  methods: {
    openModal() {
      if (this.dummy) {
        return;
      }
      this.showModal = true;
      if (this.env === "production") {
        ga("send", "event", "pressrelease", "click", "bottom_cheer_btn");
      }
    },
    closeModal() {
      this.showModal = false;
    },
    generateTwitterURL() {
      // タイトルに「|」等が含まれると URI として不正になるためエンコードする
      const text = encodeURIComponent(`${this.title} - ${this.name}のプレスリリース`);
      this.twitterURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.url)}&text=${text}`;
    },
    async getCheerUsers() {
      try {
        const response = await axios.get("/api/social_api/get_cheer_count", { params: { articleId: this.articleId } });
        // バリデーションに引っかかった場合
        // cheerUsersは空の配列のままになり応援してるユーザーは表示されない
        if (response.data.status === 9) return;

        this.cheerUsers = response.data.data.cheerInfo;
      } catch (_error) {
        // リリースの応援数の取得に失敗しただけなので何もしない
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_menu {
  text-align: right;
}

.closebtn {
  width: 24px;
  height: 24px;
  -webkit-border-radius: 12px; /* width,heightの半分 */
  -moz-border-radius: 12px;
  border-radius: 12px;
  background-color: #ccc; /* 円の色 */
  padding: 0;
  border: none;
  cursor: pointer;
  position: relative;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  float: right;
  outline: none;
}

.closebtn span {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100px;
  text-align: center;
}

.FbBtn {
  background-color: #3b5998;
  height: 47px;
  display: inline-block;
  position: relative;
  text-decoration: none;
  border-radius: 4px;
}

.FbBtn::after {
  content: "";
  position: absolute;
  top: 9px;
  left: 9px;
  width: 29px;
  height: 29px;
  background-image: url(/static/image/common/FB-Logo_white_29.png);
  background-repeat: no-repeat;
  background-size: 29px 29px;
}

.FbBtnLabel {
  color: #fff;
  position: relative;
  font-weight: bold;
  top: 13px;
  text-align: center;
  padding: 0 40px 0 60px;
}

.cheer-users-none {
  margin-left: auto;
}

.sectionBtn {
  width: 140px;
  height: 34px;

  .cheer_follow {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 15px;
    font-size: 117%;
    font-weight: bold;
    border: 2px solid #45a036;
    border-radius: 5px;
    box-sizing: border-box;
    transition: all 0.2s ease-out;
    cursor: pointer;
  }

  .svg_cheering {
    width: 15px;
    height: 14px;
    margin-right: 12px;
    position: relative;
    top: 1px;
  }

  .cheer {
    color: #45a036 !important;
    background-color: #fff;

    .cls-3 {
      fill: #45a036;
    }
  }

  .cheer:hover {
    color: #fff !important;
    background: #45a036;
    text-decoration: none;

    .cls-3 {
      fill: #fff;
    }
  }

  .cheering {
    color: #fff !important;
    background-color: #45a036;

    .cls-3 {
      fill: #fff;
    }
  }

  .cheering:hover {
    color: #45a036 !important;
    background: #fff;
    text-decoration: none;

    .cls-3 {
      fill: #45a036;
    }
  }
}

#cheer_box {
  .fb_login_box {
    max-width: 640px;
    padding: 20px;
  }

  .lets_login {
    width: 100%;
    color: #666;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
  }

  .need_fb {
    font-size: 12px;
    color: #666;
    margin-bottom: 20px;
    text-align: center;
  }

  .fb_login_guide {
    width: 100%;
    margin-bottom: 20px;
    text-align: center;
  }

  .fb_login_loading {
    display: none;
    width: 100%;
    margin-bottom: 20px;
    text-align: center;
  }

  .about_cheer {
    width: 100%;
    border-top: 1px #ededed solid;
    padding-top: 20px;

    p {
      max-width: 480px;
      color: #666;
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 10px 0;
    }

    div {
      max-width: 480px;
      font-size: 12px;
      line-height: 160%;
      color: #666;
    }
  }
}

#cheer_send {
  text-align: center;
  width: 100%;
  padding: 20px 0;

  .cheer_name {
    color: #666;
    font-size: 20px;
    font-weight: bold;
    padding: 10px 0 40px;

    .error {
      font-size: 12px;
      margin-bottom: 20px;
      height: 14px;
      color: #fff;
      z-index: 1;
      line-height: 160%;
      padding: 3px 8px 2px;
      display: none;
      background-color: #f60;
      border-radius: 3px;
    }
  }

  #fb-btn {
    margin: 0 0 20px;
    background: #364e94;
    border-radius: 22px;
    color: #fff;
    font-size: 14px;
    padding: 12px 0;
    text-align: center;
    width: 328px;
    cursor: pointer;
    border-color: transparent;

    .g-icon-flag {
      padding-right: 1px;
    }
  }

  .cheer_twitter {
    margin: 0 0 20px;

    #twitter-intent {
      display: inline-block;
      padding: 13px 0;
      background: #188adb;
      border-radius: 22px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      text-decoration: none;
      width: 328px;
      cursor: pointer;

      .g-icon-flag {
        padding-right: 1px;
        color: #fff;
      }

      span {
        color: #fff;
      }
    }
  }

  .cheer_close {
    margin: 0 0 20px;

    button {
      font-size: 14px;
      text-decoration: none;
      cursor: pointer;
    }
  }

  .cheer_effect {
    font-size: 12px;
    color: #666;
  }
}
</style>
